var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.61 92.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m97.61,46.42l-11.11-12.25,1.79-16.44-16.19-3.38L63.89,0l-15.08,6.78L33.72,0l-8.22,14.35-16.19,3.38,1.79,16.44L0,46.42l11.11,12.25-1.79,16.44,16.19,3.38,8.22,14.35,15.08-6.78,15.08,6.78,8.22-14.35,16.19-3.38-1.79-16.44,11.11-12.25Zm-27.45-11.04l-27.57,31.22-14.89-14.74c-2.16-2.14-2.18-5.62-.04-7.78,2.14-2.16,5.62-2.18,7.78-.04l6.61,6.55,19.86-22.49c2.01-2.28,5.49-2.49,7.76-.48,2.28,2.01,2.49,5.49.48,7.76Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBadgeIcon);
export default __webpack_public_path__ + "static/media/CheckmarkBadgeIcon.1e7b87f0aa22df45d50961a5c6675960.svg";
export { ForwardRef as ReactComponent };